export enum SectorTypes {
    education_nonprofit = 'education_nonprofit',
    mental_health = 'mental_health',
    corporate = 'corporate',
}
